<div class="text-primary" *ngIf="barcode$ | async as barcode">
  <div class="p-0 d-flex flex-wrap flex-column justify-content-around rounded">
    <ng-container *ngIf="card$ | async as card">
      <ng-container *ngIf="member$ | async as member">
        <div class="w-100 bg-primary barcode-content-container pt-3">
          <div class="barcode-content font-size-14 mx-2 pb-2 text-white">
            <div class="d-flex justify-content-between align-items-center" *ngIf="card$ | async as card">
              <!--Name and ID-->
              <div class="card-id text-start">
                <h5 class="mb-1 font-size-20 card-name w-100" *ngIf="memberDetails$ | async as memberDetails">
                  {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
                </h5>
                <div class="d-flex font-size-12">
                  <div>{{ card.ProductCode }}</div>
                  <div class="px-1">-</div>
                  <div>{{ card.MemberId }}</div>
                </div>
              </div>
              <!--Logo-->
              <img alt="logo image" class="card-logo" [src]="'images/logo.svg' | contentAssetImage" draggable="false" />
            </div>
            <ng-container *ngIf="!(loading$ | async)"
              ><div *ngIf="showBarcode">
                @switch (version) {
                  @case (2) {
                    <!-- Rotates the encoded value, so a screenshot stops scanning after the period. -->
                    <div class="card-qr-code bg-white mb-3 p-3">
                      <div class="qr">
                        <fgb-rotating-barcode [barcode]="barcode.Barcode" [phrase]="barcode.Phrase"></fgb-rotating-barcode>
                      </div>
                    </div>
                  }
                  @default {
                    <div class="card-qr-code bg-white mb-3">
                      <div class="qr">
                        <qrcode
                          [qrdata]="barcode.Barcode"
                          [width]="127"
                          [errorCorrectionLevel]="'M'"
                          [elementType]="'svg'"
                        ></qrcode>
                      </div>
                      <p class="font-size-12 text-black d-flex justify-content-center flex-wrap">
                        {{ 'wallet.barcode.scan' | translate }}
                      </p>
                    </div>
                  }
                }
              </div></ng-container
            >
            <ng-container *ngIf="loading$ | async">
              <div class="loading-container">
                <fgbcl-loading></fgbcl-loading>
              </div>
            </ng-container>

            <div class="card mt-3 bg-primary border-white">
              <div class="card-values p-2">
                <div class="balance text-center">
                  <label class="value">{{ pointsBalance$ | async | number: '1.0-0' }}</label>
                  <div class="font-size-14">{{ 'member.card.points.balance' | translate }}</div>
                </div>
                <div class="dash"></div>
                <div class="credit text-center">
                  <label class="value">£{{ ecash$ | async | number: '1.0-0' }}</label>
                  <div class="font-size-14">{{ 'member.card.ecash.balance' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="ecash-button-account">
              <fgb-ecash-button></fgb-ecash-button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
